import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { Card, CardContent } from "../../components/Card";

export function CompactClientCardSkeleton() {
  return (
    <Card
      sx={{
        width: "100%",
      }}
    >
      <CardContent sx={{ padding: "10px", width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            marginBottom: "16px",
            width: "100%",
            gap: 1.5,
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1 }}
          >
            <Skeleton variant="circular" width={40} height={40} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="70%" height={20} />
              <Skeleton variant="text" width="55%" height={18} />
            </Box>
          </Box>
          <Skeleton variant="circular" width={32} height={32} />
        </Box>

        <Stack spacing={1.5}>
          <Box>
            <Skeleton variant="text" width={80} height={16} sx={{ mb: 0.5 }} />
            <Skeleton variant="rounded" height={34} />
          </Box>
          <Box>
            <Skeleton variant="text" width={100} height={16} sx={{ mb: 0.5 }} />
            <Skeleton variant="rounded" height={34} />
          </Box>
          <Skeleton variant="rounded" height={36} />
        </Stack>
      </CardContent>
    </Card>
  );
}

export default CompactClientCardSkeleton;
